import React from 'react';
import CreateUserComponent from '../../../components/Admin/users/CreateUserComponent';
import { useNavigate } from 'react-router-dom';

const CreateUserPage = () => {
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/khach-hang');
    }

    return <CreateUserComponent shouldRedirect={ () => redirect() } />;
}

export default CreateUserPage;